import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  ", "\n  & > * {\n    ", "\n  }\n  background-color: ", ";\n  box-shadow: ", ";\n  transition: box-shadow 0.2s ease-out;\n  border-radius: 100%;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import IconDefault from './IconDefault';
import { SENSATION_WHITE } from '../colors';
import { SHADOW_DEFAULT } from '../shadows';
import { ICON_LARGE_SIZE, ICON_SIZE, ICON_SMALL_SIZE } from '../constants';
import { BUTTON_CIRCLE_SIZE, BUTTON_CIRCLE_SIZE_SMALL, BUTTON_CIRCLE_SIZE_TINY } from '../Button/constants';
import { absoluteCenteredStyle } from '../tokens/centered';
import { size } from '../style/size';
var SIZE = {
  tiny: BUTTON_CIRCLE_SIZE_TINY,
  small: BUTTON_CIRCLE_SIZE_SMALL,
  medium: BUTTON_CIRCLE_SIZE
};
var Wrapper = styled.div(_templateObject(), size(ICON_SIZE), absoluteCenteredStyle, SENSATION_WHITE, SHADOW_DEFAULT, function (_ref) {
  var value = _ref.$size,
      _ref$$sizeVariant = _ref.$sizeVariant,
      variant = _ref$$sizeVariant === void 0 ? 'medium' : _ref$$sizeVariant;
  return size(value != null ? value : SIZE[variant] || SIZE.medium);
});
var IconCircle = styled(function (_ref2) {
  var size = _ref2.size,
      _ref2$sizeVariant = _ref2.sizeVariant,
      sizeVariant = _ref2$sizeVariant === void 0 ? 'medium' : _ref2$sizeVariant,
      className = _ref2.className,
      props = _objectWithoutPropertiesLoose(_ref2, ["size", "sizeVariant", "className"]);

  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className,
    $size: size,
    $sizeVariant: sizeVariant
  }, /*#__PURE__*/React.createElement(IconDefault, _extends({
    size: size || (props.hasArrow ? sizeVariant === 'tiny' ? ICON_SIZE : ICON_LARGE_SIZE : sizeVariant === 'tiny' ? ICON_SMALL_SIZE : ICON_SIZE)
  }, props)));
})(_templateObject2());
export default IconCircle;